import $ from "jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger, SplitText);

const lenis = new Lenis();
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});
gsap.ticker.lagSmoothing(0);

// Text animation
document.fonts.ready.then(() => {
  requestAnimationFrame(() => {
    const textAnimated = $(".text-animation, .text-animation-p p");
    textAnimated.each(function () {
      $("body").addClass("ready");
      let tm;
      SplitText.create(this, {
        type: "lines, words, chars",
        mask: "lines",
        charsClass: "char",
        autoSplit: true,
        onSplit(self) {
          if (!tm) {
            tm = gsap.timeline({
              scrollTrigger: {
                trigger: self.elements[0],
                start: "top 80%",
                once: true,
              },
              paused: true,
            });

            self.lines.forEach((line) => {
              tm.from(
                [...line.querySelectorAll(".char")],
                {
                  y: "105%",
                  stagger: 0.005,
                },
                0,
              );
            });
          }
          return tm;
        },
      });
    });
  });
});

// Header
const burger = $(".header__burger");
const mobileMenu = $(".menu-mobile");
const mobileMenuClose = $(".menu-mobile__close, .menu-mobile__underlay, .menu-mobile a");
const menuChars = SplitText.create(".menu-mobile ul li a", {
  type: "lines, chars",
  charsClass: "char",
});

let menuOpenTL = gsap.timeline({ paused: true });
menuOpenTL
  .fromTo(
    mobileMenu,
    {
      opacity: 0,
      visibility: "hidden",
    },
    {
      opacity: 1,
      visibility: "visible",
      duration: 0.05,
    },
  )
  .fromTo(
    menuChars.chars,
    {
      y: "105%",
    },
    {
      y: 0,
      stagger: 0.01,
      duration: 0.2,
    },
  );
burger.click(function () {
  menuOpenTL.play();
});
mobileMenuClose.click(function () {
  menuOpenTL.reverse();
});

// Cursor
$(document).on("mousemove.cursor", (e) => {
  gsap.set(".cursor-icon", {
    left: e.clientX,
    top: e.clientY,
  });
});

const cursor = $(".cursor-icon");
const cursorDefault = $(".cursor-icon__default");
const cursorHover = $(".cursor-icon__hover");

$(document).on(
  "mouseenter.cursor",
  "a, button, .cursor-pointer, .section-work__filters-item",
  (e) => {
    cursor.addClass("active");
  },
);
$(document).on(
  "mouseleave.cursor",
  "a, button, .cursor-pointer, .section-work__filters-item",
  (e) => {
    cursor.removeClass("active");
  },
);
$(document).on("mouseenter.cursor", ".project-card", (e) => {
  cursor.addClass("active-hover");
  cursorDefault.hide();
  cursorHover.show();
});
$(document).on("mouseleave.cursor", ".project-card", (e) => {
  cursor.removeClass("active-hover");
  cursorDefault.show();
  cursorHover.hide();
});

// Pin animation
ScrollTrigger.matchMedia({
  "(min-width: 768px)": function () {
    if (document.querySelector(".js-pin-helper")) {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".js-pin-helper",
          start: "top top",
          end: "bottom 5%",
          scrub: 1,
          pin: true,
          pinSpacing: false,
        },
      });
    }
  },
  "(max-width: 767px)": function () {
    if (document.querySelector(".js-pin-helper")) {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".js-pin-helper",
          start: "bottom 90%",
          end: "bottom 5%",
          scrub: 1,
          pin: true,
          pinSpacing: false,
        },
      });
    }
  },
});

if (document.querySelector(".js-pin-helper-single-project")) {
  gsap.timeline({
    scrollTrigger: {
      trigger: ".js-pin-helper-single-project",
      start: "top top",
      end: "bottom 5%",
      scrub: 1,
      pin: true,
      pinSpacing: false,
    },
  });
}

// Back to top
const $header = $("header");
const $backToTop = $(".back-to-top");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $backToTop.removeClass("active");
      } else {
        $backToTop.addClass("active");
      }
    });
  },
  {
    root: null,
    threshold: 0,
  },
);

observer.observe($header[0]);
